import { backfillKeypoints } from '@/session/upload.js';
import { count, track } from '@/lib/analytics.js';

/**
 * Right after sharing is turned on: send the sessions still on this phone (the
 * last 7 days at most) that were never uploaded. Fire-and-forget — failures are
 * queued and retried, and the frames are kept until they go.
 */
export async function sendSessionsOnPhone(uid: string): Promise<void> {
  const sent = await backfillKeypoints(uid).catch(() => 0);
  track('keypoint_backfill', { sessions: count(sent) });
}
